<h2 mat-dialog-title>Nous vous avons envoyé un E-Mail</h2>
<div mat-dialog-content>
    <p>Pour continuer, saisissez le code de vérification à 6 chiffres envoyé à votre adresse mail.</p>
    <br/>
    <form (ngSubmit)="onYesClick()" [formGroup]="codeForm">
        <mat-form-field>
            <mat-label>Code</mat-label>
            <input formControlName="code" matInput class="text">
        </mat-form-field>
    </form>
    <p>Un problème ? <a href="mailto:contat@lybox.fr">Contactez nous</a></p>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-primary float-right">
        Valider
    </button>
</div>
